// Get a Firestore instance
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const fapp = firebase.initializeApp({
  apiKey: `${process.env.VUE_APP_FIREBASE_API_KEY}`,
  projectId: `${process.env.VUE_APP_FIREBASE_PROJECT_ID}`
});

export const fsdb = fapp.firestore();
export const auth = fapp.auth();